import { render } from "./mvt-mortgage-new.vue?vue&type=template&id=4be2eece"
import script from "./mvt-mortgage-new.js?vue&type=script&lang=js"
export * from "./mvt-mortgage-new.js?vue&type=script&lang=js"

import "./mvt-mortgage-new.vue?vue&type=style&index=0&id=4be2eece&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__